import { useRouter } from '@tanstack/react-router';
import { MAIN_CONTENT_SCROLL_SELECTOR } from 'constants/scroll';
import { useEffect } from 'react';

/**
 * Resets the main content area to the top when navigating to a new page.
 */
export function useResetMainContentScroll() {
  const router = useRouter();

  useEffect(() => {
    let isNewNavigation = false;

    const unsubscribeHistory = router.history.subscribe(({ action }) => {
      isNewNavigation = action.type === 'PUSH' || action.type === 'REPLACE';
    });

    const unsubscribeRendered = router.subscribe('onRendered', ({ toLocation }) => {
      if (!isNewNavigation || toLocation.hash) {
        return;
      }

      document.querySelector(MAIN_CONTENT_SCROLL_SELECTOR)?.scrollTo({ top: 0, left: 0 });
    });

    return () => {
      unsubscribeHistory();
      unsubscribeRendered();
    };
  }, [router]);
}
